import { AddressMhs } from "./address-mhs";
import { CoverageMhs } from "./coverage-mhs";

export class ApplicantMhs {
    firstName: string;
    lastName: string;
    ssn: string;
    gender: string;
    email: string;
    communicationPreference: string;
    relationshipToEmployee: string;
    stateOfResidence: string;
    enrollmentType: string;
    birthDate: string;
    stateOfBirth: string;
    countryOfBirth?: string;
    countryOfResidence?: string;
    placeOfBirth: string;
    phone: string;
    address: AddressMhs;
    coverage: CoverageMhs[];
}